import { Flex } from '@chakra-ui/react';
import { PropsWithChildren, ReactNode } from 'react';

export function NavBar({
  logo,
  children
}: PropsWithChildren<{ logo: ReactNode }>): JSX.Element {
  return (
    <Flex
      borderBottom="1px solid"
      borderBottomColor="palette_gray.10"
      w="100%"
      h="10%"
      justifyContent="space-between"
      px="space_unit.x2"
      alignItems="center"
    >
      <Flex
        justifyContent="center"
        alignItems="center"
        sx={{
          '&  >svg': {
            h: '50px',
            w: 'fit-content',
            ml: '-14px'
          }
        }}
      >
        {logo}
      </Flex>
      {children}
    </Flex>
  );
}
